<template>
  <div class="survey-info">
    <img v-if="image"
      class="survey-info__img"
      src="@/assets/img/survey-logo.svg"
      alt="Survey image"
    />
    <h1 class="survey-info__title">{{ title }}</h1>
    <p class="survey-info__description">{{ description }}</p>
    <v-btn class="survey-info__btn"
      v-if="actionName.length"
      color="blue"
      dark
      x-large
      width="256"
      @click="submit"
    >
      {{ actionName }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    image: {
      type: Boolean,
      default: false,
    },
    actionName: {
      type: String,
      required: true,
    },
  },

  methods: {
    submit() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.survey-info {
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;
  max-width: 636px;
  margin: 0 auto;
  padding: 48px 96px;
  text-align: center;

  &__img {
    margin-bottom: 32px;
  }

  &__title {
    color: $main--headers;
    font-size: 28px;
    line-height: 33px;
    margin-bottom: 16px;
  }

  &__description {
    color: $main--text;
    opacity: 0.7;
  }

  &__btn {
    margin-top: 48px;
    min-width: 256px;
  }
}
</style>
